import { TResponse } from '../../../../core/httpClient';
import { baseApi } from '../../../../core/redux/store/api';
import { API_VERSION } from '../../../../core/redux/store/api/constants';
import { GameDto, ApiResponseListGameDto, GameScoreDto } from '../../../../models';
import { TGameType } from '../../helpers';
import { ExecuteGameEventRequestPayload, User } from '../../types';

export const gameService = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    getPrincipalMe: build.query<User, void>({
      query: () => ({
        method: 'GET',
        url: `${API_VERSION}/principal/me`,
      }),
      transformResponse: (response: TResponse<User>) => response?.data,
    }),
    getGamesList: build.query<ApiResponseListGameDto, void>({
      query: () => ({
        method: 'GET',
        url: `${API_VERSION}/game/list`,
      }),
      transformResponse: (response: TResponse<ApiResponseListGameDto>) => response?.data,
    }),
    getScore: build.query<GameScoreDto, { gameCode?: TGameType }>({
      query: ({ gameCode }) => ({
        method: 'GET',
        url: `${API_VERSION}/game/progress/score?gameCode=${gameCode}`,
      }),
      transformResponse: (response: TResponse<GameScoreDto>) => response?.data,
      providesTags: (result, error, arg) => [{ type: 'GameScore', id: arg.gameCode }],
      keepUnusedDataFor: 0,
    }),
    executeGameStart: build.mutation<any, Omit<ExecuteGameEventRequestPayload, 'eventId'>>({
      query: ({ gameCode, properties }) => ({
        method: 'POST',
        url: `${API_VERSION}/game/event/execute`,
        body: { gameCode, properties, eventId: 'start' },
      }),
      transformResponse: (response: TResponse<any>) => response?.data,
    }),
    executeGameEnd: build.mutation<any, Omit<ExecuteGameEventRequestPayload, 'eventId'>>({
      query: ({ gameCode, properties }) => ({
        method: 'POST',
        url: `${API_VERSION}/game/event/execute`,
        body: { gameCode, properties, eventId: 'end' },
      }),
      transformResponse: (response: TResponse<any>) => response?.data,
    }),
    executeGameWin: build.mutation<any, ExecuteGameEventRequestPayload>({
      query: ({ gameCode, properties, eventId }) => ({
        method: 'POST',
        url: `${API_VERSION}/game/event/execute`,
        body: { gameCode, properties, eventId },
      }),
      transformResponse: (response: TResponse<any>) => response?.data,
    }),
  }),
});

export const {
  useGetGamesListQuery,
  useGetScoreQuery,
  useExecuteGameStartMutation,
  useExecuteGameEndMutation,
  useExecuteGameWinMutation,
  useGetPrincipalMeQuery,
} = gameService;

export const { getGamesList, getScore, getPrincipalMe } = gameService.endpoints;
